import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  @Input() size?: number;
  @Input() opacity?: string;
  @Input() center?: boolean;

  constructor() { }

  ngOnInit() {
  }

}
